import {Component} from '@angular/core';

@Component({
  selector: 'app-a-song-hub',
  standalone: true,
  imports: [],
  templateUrl: './a-song-hub.component.html',
  styleUrl: './a-song-hub.component.scss',
})
export class ASongHubComponent {

}
